import { computed, Directive, input, signal } from '@angular/core';
import { cn } from '@shared/helpers/cn';

@Directive({
  selector: '[appInputText]',
  standalone: true,
  host: {
    '[class]': 'styles()',
    '[style.border-color]': 'focused() ? focusColor() : borderColor()',
    '[style.--tw-ring-color]': 'focusColor()',
    '(focus)': 'focused.set(true)',
    '(blur)': 'focused.set(false)',
  },
})
export class AppInputTextDirective {
  #base =
    'w-full bg-gray-50 rounded-xl border border-gray-200 disabled:text-gray-400 disabled:pointer-events-none  px-4 py-3 focus:ring-2 focus:outline-none';
  tone = input<'default' | 'location' | 'green' | 'blue' | 'red'>('default');
  class = input<string>();
  protected readonly focused = signal(false);

  protected readonly borderColor = computed(() => {
    switch (this.tone()) {
      case 'location':
        return 'var(--app-theme-primary-border)';
      case 'green':
        return '#bbf7d0';
      case 'blue':
        return '#bfdbfe';
      case 'red':
        return '#fecaca';
      default:
        return '#e5e7eb';
    }
  });

  protected readonly focusColor = computed(() => {
    switch (this.tone()) {
      case 'location':
        return 'var(--app-theme-primary)';
      case 'green':
        return '#16a34a';
      case 'blue':
        return '#2563eb';
      case 'red':
        return '#dc2626';
      default:
        return '#a855f7';
    }
  });

  public styles = computed(() => {
    return cn(this.#base, this.class());
  });
}
